import rals from './ralColors';

export function animationDelay(index) {
  return `${(Math.acosh(index + 3) - 1.5)}s`;
}

export function convertRalToHex(ral) {
  return rals[ral] || 'transparent';
}
